/* libs */
import { createLogic } from "redux-logic";
/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as controlPanelActions from "../../actions/controlPanelActions";

const selectThemesFailureLogic = createLogic({
	type: ActionTypes.SELECT_PAGE_FAILURE,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(controlPanelActions.displayError(action.errorMessage.message));
		done();
	},
});

export default [selectThemesFailureLogic];
